import { Component, EventEmitter, Output } from '@angular/core';
import { AbstractModalBase } from '@lmnop/angular-core';
import {
    AngularWebsiteCoreIoCKeys,
    IAngularWebsiteCoreIoCContainer,
} from 'angular-website-core-src';
import { IoCContainer } from '@lmnop/web-core';
import { IWebsiteCoreSettings } from '@lmnop/website-core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    template: '',
    selector: 'angular-website-core-modal-base',
})
export abstract class ModalBase extends AbstractModalBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.ioc = IoCContainer.get(
            AngularWebsiteCoreIoCKeys.IAngularWebsiteCoreIoCContainer
        );
        this.settings = this.ioc.settings;
    }

    protected ioc: IAngularWebsiteCoreIoCContainer;
    protected settings: IWebsiteCoreSettings;
}
